// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"4918":"914d2cbeaf6ab838","5718":"1b5ef5691516f7e2"}[chunkId] + ".css";
};